import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import Notification from '../shared/Notification';
import styles from './settings.module.css';

const RecruiterSettings = () => {
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [deletePassword, setDeletePassword] = useState('');
    const [error, setError] = useState(''); 
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem('token'); 
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/recruiter/login'); 
                    return;
                }

                const response = await axios.get('/api/authRecruiter/get-name-email', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setEmailOrPhone(response.data.emailOrPhone);
                setName(response.data.name);
            } catch (error) {
                console.error('Error fetching user data:', error);
                if (error.response.status === 401) {
                    localStorage.setItem('notification', 'Session Timed-out, , Please login Again !');
                    navigate('/recruiter/login');
                    return;
                }

            }
        };

        fetchUserData();
    }, [navigate]);

    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }
    }, []);

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleLogout = () => {
        // Handle logout logic
        localStorage.removeItem('token'); // Remove the token from localStorage
        // console.log('Logged out');
        navigate('/'); // Redirect to login page
    };

    const handleDeleteProfile = async () => {
        // Handle delete profile logic
        if (deletePassword) {
            try {
                const response = await axios.post('/api/authRecruiter/delete-profile', {
                    password: deletePassword
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                        }});
                // console.log(response.data.message);
                localStorage.removeItem('token'); // Remove the token from localStorage
                navigate('/'); // Redirect to login page
            } catch (error) {
                console.error('Error deleting profile:', error);
            }
        } else {
            // console.log('Please enter your password to delete your profile.');
        }
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleDeletePasswordChange = (e) => {
        setDeletePassword(e.target.value);
    };

    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <div className={styles.settingsContainer}>
                <h2>Settings</h2>
                <p>You are currently logged in</p>
                <div className={styles.settingsInfo}>
                    <p><strong>Email:</strong> {emailOrPhone}</p>
                    <p><strong>Name:</strong> {name}</p>
                </div>
                <button className={styles.logoutButton} onClick={handleLogout}>Logout</button>
                <div className={styles.passwordChange}>
                    <label htmlFor="password">Change Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={handlePasswordChange}
                    />
                </div>
                <div className={styles.deleteProfile}>
                    <label htmlFor="delete-password">Enter Password to Delete Profile:</label>
                    <input
                        type="password"
                        id="delete-password"
                        value={deletePassword}
                        onChange={handleDeletePasswordChange}
                    />
                    <button className={styles.deleteButton} onClick={handleDeleteProfile}>Delete Profile</button>
                </div>
            </div>
        </div>
    );
};

export default RecruiterSettings;